<template>
  <div class="main-sidebar">
    <div v-if="(parceiroRedeNeutraID > 0)">
      <a v-on:click.prevent="toggleMenu('/provisionamento-onus', true)" id="hidden-main-sidebar-home" class="d-none"></a>
      <ul class="list-group list-group-flush">
        <a v-on:click.prevent="toggleMenu('/provisionamento-onus')"
            v-bind:class="menuClass('/provisionamento-onus')"
            href="/provisionamento-onus"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
          <span>
            <img src="/image/icon/fiber-icon-22.png" width="17" class="me-2">Provisionamento
          </span>
        </a>
        <a v-on:click.prevent="toggleMenu('/provisionamento-onus/pre-cadastro')"
            v-bind:class="menuClass('/provisionamento-onus/pre-cadastro')"
            href="/provisionamento-onus/pre-cadastro"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
          <span>
            <font-awesome-icon :icon="['far', 'hourglass']" fixed-width class="me-2" />Pré-cadastro de ONUs
          </span>
        </a>
      </ul>
    </div>

    <div v-if="(!parceiroRedeNeutraID)">
      <a v-on:click.prevent="toggleMenu('/', true)" id="hidden-main-sidebar-home" class="d-none"></a>
      <ul class="list-group list-group-flush">

        <a v-on:click.prevent="toggleMenu('/')"
            v-bind:class="menuClass('/')"
            href="/"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
          <span>
            <font-awesome-icon :icon="['fas', 'tachometer-alt']" fixed-width class="me-2" />Dashboard
          </span>
        </a>

        <a v-on:click.prevent="toggleMenu('/clientes')"
            v-bind:class="menuClass('/clientes')"
            href="/clientes"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
          <span>
            <font-awesome-icon :icon="['fas', 'user']" fixed-width class="me-2" />Clientes
          </span>
        </a>

        <a v-on:click.prevent="toggleMenu('/isp/conexoes')"
            v-bind:class="menuClass('/isp/conexoes')"
            href="/isp/conexoes"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
          <span>
            <font-awesome-icon :icon="['fas', 'network-wired']" fixed-width class="me-2" />Conexões
          </span>
        </a>

        <a v-on:click.prevent="toggleMenu('/helpdesk')"
            v-bind:class="menuClass('/helpdesk')"
            href="/helpdesk"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
          <span>
            <font-awesome-icon :icon="['fas', 'hands-helping']" fixed-width class="me-2" />Helpdesk
          </span>
          <span class="badge badge-primary">0</span>
        </a>

        <a v-on:click.prevent="toggleMenu('/assinaturas-isp')"
            v-bind:class="menuClass('/assinaturas-isp')"
            href="/assinaturas-isp"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
          <span>
            <font-awesome-icon :icon="['fas', 'retweet']" fixed-width class="me-2" />Assinaturas
          </span>
        </a>

        <a v-on:click.prevent="toggleMenu('/provisionamento-onus')"
            v-bind:class="menuClass('/provisionamento-onus')"
            href="/provisionamento-onus"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
          <span>
            <img src="/image/icon/fiber-icon-22.png" width="17" class="me-2">Provisionamento
          </span>
        </a>

        <a v-on:click.prevent="toggleMenu('/controle-patrimonial')"
            v-bind:class="menuClass('/controle-patrimonial')"
            href="/controle-patrimonial"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
          <span>
            <font-awesome-icon :icon="['fas', 'window-restore']" fixed-width class="me-2" />Controle patrimonial
          </span>
        </a>

        <a v-on:click.prevent="toggleSubmenu('configuracoes')"
            href="#"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center has-sub">
          <span>
            <font-awesome-icon :icon="['fas', 'wrench']" fixed-width class="me-2" />Configurações
          </span>
          <font-awesome-icon v-if="!submenuAberto('configuracoes')" :icon="['fas', 'angle-right']" fixed-width class="me-2" />
          <font-awesome-icon v-if="submenuAberto('configuracoes')" :icon="['fas', 'angle-down']" fixed-width class="me-2" />
        </a>

        <a v-if="submenuAberto('configuracoes')"
            v-on:click.prevent="toggleMenu('/configuracoes/servidores')"
            v-bind:class="menuClass('/configuracoes/servidores')"
            href="/configuracoes/servidores"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center is-sub">
          <span>
            <font-awesome-icon :icon="['fas', 'server']" fixed-width class="me-2" />Servidores
          </span>
        </a>

        <a v-if="submenuAberto('configuracoes')"
            v-on:click.prevent="toggleMenu('/configuracoes/grupos-ip-pool')"
            v-bind:class="menuClass('/configuracoes/grupos-ip-pool')"
            href="/configuracoes/grupos-ip-pool"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center is-sub">
          <span>
            <font-awesome-icon :icon="['fas', 'poll']" fixed-width class="me-2" />IP Pool
          </span>
        </a>

        <a v-if="submenuAberto('configuracoes')"
            v-on:click.prevent="toggleMenu('/configuracoes/catalogo')"
            v-bind:class="menuClass('/configuracoes/catalogo')"
            href="/configuracoes/catalogo"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center is-sub">
          <span>
            <font-awesome-icon :icon="['fas', 'briefcase']" fixed-width class="me-2" />Catálogo
          </span>
        </a>

        <!--
        <a v-on:click.prevent="toggleMenu('configuracoes')"
            v-if="submenuAberto('configuracoes')"
            href="#"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center is-sub">
          <span>
            <font-awesome-icon :icon="['far', 'keyboard']" fixed-width class="me-2" />Campos do sistema
          </span>
        </a>

        <a v-on:click.prevent="toggleMenu('configuracoes')"
            v-if="submenuAberto('configuracoes')"
            href="#"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center is-sub">
          <span>
            <font-awesome-icon :icon="['fas', 'users']" fixed-width class="me-2" />Funcionários
          </span>
        </a>
        -->

        <a v-if="submenuAberto('configuracoes')"
            v-on:click.prevent="toggleMenu('/configuracoes/helpdesk')"
            v-bind:class="menuClass('/configuracoes/helpdesk')"
            href="/configuracoes/helpdesk"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center is-sub">
          <span>
            <font-awesome-icon :icon="['fas', 'hands-helping']" fixed-width class="me-2" />Helpdesk
          </span>
        </a>

        <a v-if="submenuAberto('configuracoes')"
            v-on:click.prevent="toggleMenu('/configuracoes/parceiros-rede-neutra')"
            v-bind:class="menuClass('/configuracoes/parceiros-rede-neutra')"
            href="/configuracoes/parceiros-rede-neutra"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center is-sub">
          <span>
            <font-awesome-icon :icon="['fas', 'users']" fixed-width class="me-2" />Parceiros de rede neutra
          </span>
        </a>

        <a v-if="submenuAberto('configuracoes')"
            v-on:click.prevent="toggleMenu('/configuracoes/colaboradores')"
            v-bind:class="menuClass('/configuracoes/colaboradores')"
            href="/configuracoes/colaboradores"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center is-sub">
          <span>
            <font-awesome-icon :icon="['fas', 'users']" fixed-width class="me-2" />Colaboradores
          </span>
        </a>

        <a v-if="submenuAberto('configuracoes')"
            v-on:click.prevent="toggleMenu('/configuracoes/contas-de-usuario')"
            v-bind:class="menuClass('/configuracoes/contas-de-usuario')"
            href="/configuracoes/contas-de-usuario"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center is-sub">
          <span>
            <font-awesome-icon :icon="['fas', 'key']" fixed-width class="me-2" />Contas de usuário
          </span>
        </a>

        <!--
        <a v-on:click.prevent="toggleMenu('configuracoes')"
            v-if="submenuAberto('configuracoes')"
            href="#"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center is-sub">
          <span>
            <font-awesome-icon :icon="['far', 'building']" fixed-width class="me-2" />Meu negócio
          </span>
        </a>
        -->
      </ul>
    </div>
  </div>
</template>

<script>
import store from '@/store'

export default {
  name: 'MainSidebar',
  data() {
    return {
      lastClicked: '',
      submenu: '',
      parceiroRedeNeutraID: 0,
    }
  },
  methods: {
    toggleMenu(menu, veioDoHidden) {
      this.lastClicked = menu;

      if (this.$route.path === menu) {
        return;
      }

      this.$router.push({ path: menu });
      //event.currentTarget.classList.toggle('active');

      if (!veioDoHidden) {
        document.getElementById('sidebar-toggle').click();
      }
    },
    toggleSubmenu(submenu) {
      if (this.submenu == submenu) {
        this.lastClicked = '';
        this.submenu = '';
        return;
      }
      this.lastClicked = submenu;
      this.submenu = submenu;
      //event.currentTarget.classList.toggle('active');
    },
    menuClass(menu) {
      const classes = [];
      let menuMatch = false;

      /*if (menu === '/') {
        menuMatch = (this.$route.path === menu);
      } else {
        menuMatch = (this.$route.path.includes(menu));
      }*/
      menuMatch = (this.$route.path === menu);

      if (menuMatch) {
        classes.push('active');
      }

      return classes;
    },
    submenuClass(submenu) {
      return [{submenu}];
    },
    submenuAberto(submenu) {
      return (this.submenu === submenu);
    },

    loadUserInfo() {
      const userData = store.getters['auth/getUserData'];
      this.parceiroRedeNeutraID = userData.parceiro_rede_neutra_id;
    },
  },

   created() {
    setInterval(() => {
      this.loadUserInfo();
    }, 1000);
  },
}
</script>

<style>
.main-sidebar {
  display: none;
  z-index: 5;
  width: 250px;
  height: calc(100vh - 100px);
  color: #ddd;

  position:absolute;
  top: 100px;
  left: 0px;
  overflow-y: auto;
}


.main-sidebar .list-group-item {
  height: 44px;
  background-color: transparent !important;
  color: #aaa;
  line-height: 1.42857143;
  border-left: 4px solid transparent;
}

.main-sidebar .list-group-item.is-sub {
  height: 34px;
  padding-left: 40px;
  background-color: rgba(150, 150, 150, 0.05) !important;
}

.main-sidebar .list-group-item:hover {
  background-color: rgba(0, 0, 0, 0.2) !important;
  color: #fff;
}


/* STYLING SCROLLBAR */
::-webkit-scrollbar {
  width: 1vw; /* THIS WILL RESET THE DEFAULT SCORLLBAR STYLING */
}

/* TO STYLE THE SCROLLBAR TRACK */
::-webkit-scrollbar-track {
  background-color: rgba(150, 150, 150, 0.05); /* THIS WILL SET THE COLOR OF THE SCROLLBAR TRACK */
}

/* TO STYLE THE SCROLLBAR THUMB */
::-webkit-scrollbar-thumb {
  background-color: #71717152;
  border: 0.3vw solid #29d8ff32;
  border-radius: 5vw;
}
</style>
